// ------- 任务相关 --------
import fetch from './http'

// 任务列表
export function taskList() {
    return fetch({
        url: '/task/task-list'
    })
}
// 领取任务奖励
export function getTask(tid) {
    return fetch({
        url: '/task/get-task',
        params: {
            tid
        }

    })
}